import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import Select from 'react-select';

export const ReasonModal = ({
  showModal,
  reasonError,
  handleReasonChange,
  reasonData,
  comment,
  handleComment,
  commentError,
  disabled,
  addFavourite,
  setReasonError,
  setReason,
  reason,
  setCommentError,
  setShowModal,
}) => {
  return (
    <>
      <Modal show={showModal} backdrop="static" centered>
        <Modal.Header
          closeButton
          onClick={() => {
            setReason(null);
            setReasonError(null);
            setCommentError(null);
            setShowModal(false);
          }}
        >
          <Modal.Title><span className='font-weight-bold'>Add to Favourites</span></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label className="form-label mb-2" htmlFor="reason">
            Reason:
          </label>
          <Select
            id="reason"
            className={`${reasonError && 'react-select'}`}
            classNamePrefix={`${reasonError && 'react-select'}`}
            value={reasonData?.find((r) => r.value === reason)}
            onChange={handleReasonChange}
            isSearchable={true}
            options={reasonData}
          />
          {reasonError && (
            <small
              className="text-danger"
              style={{ display: 'block' }}
            >
              {reasonError}
            </small>
          )}
          <label className="form-label mb-2 mt-2" htmlFor="comments">
            Comments:
          </label>
          <input
            id="comments"
            autoComplete="off"
            className={`form-control d-block w-100`}
            type="text"
            value={comment}
            onChange={handleComment}
            name="comment"
            required
          />
          {commentError && (
            <small className="text-danger">{commentError}</small>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant={
              comment !== null && disabled === true
                ? 'success'
                : 'primary'
            }
            onClick={(event) => addFavourite(event)}
            disabled={comment !== null && disabled === true}
          >
            {comment !== null && disabled === true
              ? 'Adding...'
              : 'Add'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
